<template>
  <Layout
    :title="meta.title"
    max-width="100%"
  >
    <div class="cgv-proposals">
      <ProposalFilters
        :product-id="productID"
        @paginate="paginate"
      />

      <div class="is-card">
        <ProposalTable
          :proposals="proposal.list"
          @csv="downloadCSV"
          @paginate="paginate"
        />

        <ThePagination
          :data="pagination.data"
          @paginate="paginate"
        />
      </div>
    </div>
  </Layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import seo from '@/utils/seo';

import config from '@/data/config';

import loadingMixin from '@/mixins/loadingView.mixin';

import Layout from '@/layouts/Layout.vue';
import ProposalFilters from '@/components/ProposalFilters.vue';
import ProposalTable from '@/components/ProposalTable.vue';
import ThePagination from '@/components/ThePagination.vue';

import {
  proposals as proposalsAPI,
} from '@/services';

export default {
  name: 'CGVProposals',
  components: {
    Layout,
    ProposalFilters,
    ProposalTable,
    ThePagination,
  },
  mixins: [
    loadingMixin,
  ],
  data() {
    return {
      meta: {
        title: 'Crédito com Garantia em Veículo',
      },
      message: null,
      proposal: {
        list: [],
      },
      pagination: {
        data: {},
      },
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'app/isMobile',
      filters: 'proposal/validFilters',
    }),
    productID() {
      return config.PRODUCT_ID_CGV;
    },
  },
  async mounted() {
    await this.getSuppliersList(this.productID);

    this.paginate();
  },
  methods: {
    ...mapActions({
      getSuppliersList: 'app/SET_SUPPLIERS',
    }),

    // api
    async paginate() {
      this.loading = true;

      let filterPage = sessionStorage.getItem('filters');
      if (filterPage) {
        filterPage = JSON.parse(filterPage);
      }

      this.$set(this.pagination, 'data', {});
      this.$set(this.proposal, 'list', []);

      await proposalsAPI
        // PRD-1272: this.filters (form) precisa vencer filterPage (sessionStorage).
        .getProposals({ ...filterPage, ...this.filters, product_id: this.productID })
        .then(({ data }) => {
          this.$set(this.pagination, 'data', data);
          this.$set(this.proposal, 'list', data.data);
        })
        .catch((err) => this.handlerError(err))
        .finally(() => {
          this.loading = false;
        });
    },

    async downloadCSV() {
      this.loading = true;

      await proposalsAPI
        .downloadCSV({ ...this.filters, product_id: this.productID, output: 'csv' })
        .then((data) => {
          const blob = new Blob([`\ufeff${data}`], { type: 'text/csv;charset=utf-8' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', 'propostas.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => this.handlerError(err))
        .finally(() => {
          this.loading = false;
        });
    },

    // handlers
    handlerError(err) {
      let message = err?.response?.data?.error?.message
        || (err?.error?.response?.data?.error?.message
        || err?.error?.data?.message
        || err?.message
        || err);

      if (err?.response?.data?.error?.errors) {
        const errors = Object.values(err?.response?.data?.error?.errors);

        message = message.concat(`<br> - ${errors.map((error) => error).join('<br> - ')}`);
      }

      this.setMessage(message);
    },
    setMessage(message) {
      this.message = message;
    },
  },
  metaInfo() {
    return seo.meta(this.meta);
  },
};
</script>
<style lang="scss" scoped>
.cgv-proposals {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
</style>
